import axios from "axios";
import apiUrl from "./apiConfig";

axios.defaults.withCredentials = true;

export const createSmiIncident = ({ data, patientId }) => {
  return axios.post(`${apiUrl}/record-builder/smi-incident`, data, {
    params: { patientId },
  });
};

export const updateSmiDetail = ({ data, patientId }) => {
  return axios.put(`${apiUrl}/record-builder/smi-detail`, data, {
    params: { patientId },
  });
};

export const createSmiHistory = ({ data, patientId }) => {
  return axios.post(`${apiUrl}/record-builder/smi-history`, data, {
    params: { patientId },
  });
};

export const getSmiDate = (patientId) => {
  return axios(`${apiUrl}/getSmiDate`, { params: { patientId } });
};